(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kb-education-article"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-kb-copy]');
    if (!button) return;
    const root = button.closest('[data-kb-share]');
    const status = root.querySelector('.kb-share__status');
    const input = root.querySelector('.kb-share__fallback');
    status.textContent = '';
    button.disabled = true;
    let copied = false;
    try {
      await navigator.clipboard.writeText(button.dataset.url);
      copied = true;
    } catch {
      input.hidden = false;
      input.focus();
      input.select();
      try { copied = document.execCommand('copy'); } catch {}
    }
    input.hidden = copied;
    status.textContent = copied ? button.dataset.success : button.dataset.error;
    button.disabled = false;
    if (copied) button.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
